<template>
  <div class="integralUser seller-style">
    <h2 class="f18 fb normal gray_2">凭证审核</h2>
    <div class="box30"></div>
    <div class="flex items-center mar15-b">
      <div class="lable">采购单号：</div>
      <el-input class="w200 mar20_r" placeholder="请输入采购单号" v-model.trim="search.orderId"></el-input>
      <div class="lable">收货人：</div>
      <el-input class="w200 mar20_r" placeholder="请输入收货人" v-model.trim="search.linkman"></el-input>
    </div>
    <div class="flex items-center justify-between mar20-b">
      <div class="flex items-center">
        <div class="lable">审核状态：</div>
        <el-select class="w240" v-model="search.approvalStatus" placeholder="请选择审核状态">
          <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
        <div class="lable">日期：</div>
        <el-date-picker
          class="mar20_r"
          v-model="timeList"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <div>
        <el-button type="primary" @click="searchList">查询</el-button>
        <el-button @click="resetList">重置</el-button>
      </div>
    </div>
    <!-- approvalStatus -->
    <div class="flex items-center text-center bg-f5 h40 mar10-b">
      <div class="flex-auto">货品</div>
      <div class="w60">数量</div>
      <div class="w80">价格</div>
      <div class="w80">合计金额</div>
      <div class="w200">提货凭证</div>
      <div class="w80">状态</div>
      <div class="w210">操作</div>
    </div>
    <template v-if="list.length">
      <div class="bor-gray" v-for="item in list" :key="item.id">
        <div class="bg-f5 h30 flex items-center">
          <span class="pad10-lr">{{ item.orderTime }}</span>
          <span class="pad10-lr">订单编号：{{ item.orderId }}</span>
          <span class="pad10-lr">收货人：{{ item.linkman }}</span>
        </div>
        <div class="flex pad10-tb">
          <div class="flex-auto">
            <div class="flex" v-for="(good, index) in item.orderGoodsList" :key="index">
              <!-- 货品 -->
              <div class="flex flex-auto pad20-l">
                <img class="good-img" :src="good.goodsPic" />
                <div class="flex flex-column justify-between pad10-l">
                  <div>{{ good.goodsName }}</div>
                  <div>规格：{{ good.goodsSpec }}</div>
                </div>
              </div>
              <!-- 数量 -->
              <div class="w60 flex items-center justify-center">{{ good.goodsQuantity }}</div>
              <!-- 价格 -->
              <div class="w80 flex items-center justify-center">￥{{ good.sellFactPrice }}</div>
            </div>
          </div>
          <!-- 合计金额 -->
          <div class="w80 flex items-center justify-center">￥{{ item.fMoney }}</div>
          <!-- 提货凭证 -->
          <div class="pad10-l pad5-r w200 flex flex-wrap items-center">
            <img class="img" v-for="(item, index) in item.sellerVoucherImgUrl" :key="index" :src="item" />
          </div>
          <!-- 状态 -->
          <div class="w80 flex items-center justify-center">
            <span class="blue" v-if="item.approvalStatus === 0">未审核</span>
            <span class="green" v-if="item.approvalStatus === 1">已通过</span>
            <span class="red" v-if="item.approvalStatus === 2">已驳回</span>
          </div>
          <!-- 操作 -->
          <div class="w210 flex items-center justify-center">
            <template v-if="item.approvalStatus === 0">
              <el-button type="primary" size="mini" @click="audit(item.id)">通过</el-button>
              <el-button type="danger" size="mini" @click="reject(item.id)">驳回</el-button>
            </template>
            <template v-if="item.approvalStatus === 2">
              <el-button type="danger" size="mini" @click="rejectRause(item.rejectReason)">驳回原因</el-button>
            </template>
          </div>
        </div>
      </div>
      <div class="flex items-center mar40-t">
        <div class="gray9 flex-auto">共 {{ pageTotal }} 条记录 第 {{ pageNum }} / {{ totalPage }} 页</div>
        <el-pagination
          layout="prev, pager, next, sizes, jumper"
          background
          hide-on-single-page
          :page-size.sync="pageSize"
          :page-count="totalPage"
          :current-page.sync="pageNum"
          :page-sizes="[30, 50, 100]"
          @size-change="sizeChange"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </template>
    <div v-else class="pad30-tb bor-gray flex items-center justify-center">暂无订单</div>
    <el-dialog title="确认自提" :visible.sync="dialogVisible" width="30%">
      <div>
        <div class="mar10-b">
          <span>请输入提货码：</span>
          <el-input class="w240" v-model="input" placeholder="请输入提货码"></el-input>
        </div>
        <div></div>
        <div class="f12 red mar10-b">提货码可向提货人索要，同时请验证司机车牌和身份</div>
        <div class="mar10-b">卖家上传凭证（仅支持图片，最多5张）</div>
        <el-upload
          class="mar10-b"
          :action="`${env.VUE_APP_fileserver}persistentUpload`"
          :limit="5"
          :file-list="photoList"
          list-type="picture-card"
          :on-success="uploadSuccess"
          :before-upload="uploadBefore"
          :on-remove="uploadRemove"
          :on-exceed="uploadExceed"
        >
          <!-- <img v-if="setSubForm.shareImg" :src="setSubForm.shareImg" class="avatar" /> -->
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div class="flex items-center mar10-b">
          <span>提货单号：</span>
          <el-input class="w240" v-model="input" placeholder="请输入提货单号"></el-input>
        </div>
        <div class="mar10-b">温馨提示：</div>
        <div class="mar10-b">为避免交易风险，确认提货前请上传提货单等交货凭证并填写提货人提供的提货码后确认自提</div>
        <div>
          点击“确认自提”，即视为您按照买家实际下单的具体信息（包括但不限于货品的品类、数量、质量标准、自提车辆信息等）交付，请勿将货品转让给其他人，
          且不得进行套现等不正当的行为。请您务必确保操作准确无误!否则，由此产生的风险和责任将由您自行承担。
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="consImg">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      photoList: [],
      env: process.env,
      input: "",
      dialogVisible: false,
      timeList: [],
      search: {
        startTime: "",
        endTime: "",
        orderId: "",
        linkman: "",
      },
      // 0-未审核 1-已通过 2-已驳回
      statusList: [
        {
          id: 0,
          name: "未审核",
        },
        {
          id: 1,
          name: "已通过",
        },
        {
          id: 2,
          name: "已驳回",
        },
      ],

      list: [],

      pageSize: 10,
      pageNum: 1,
      totalPage: 1,
      pageTotal: 1,
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.getList();
  },
  methods: {
    consImg() {
      console.log("图片列表", this.photoList);
    },
    // 上传图片之前
    uploadBefore(file) {
      const { size, type } = file;
      const isVerify = /(jpg|bmp|jpeg|png)$/.test(type);
      const isLt3M = size / 1024 / 1024 < 50;

      if (!isVerify) {
        this.$message.error("上传必须是JPG/BMP/JPEG/PNG/格式");
      } else if (!isLt3M) {
        this.$message.error("上传大小不能超过 50MB");
      }
      return isVerify && isLt3M;
    },
    // 上传图片成功之后
    uploadSuccess(res) {
      console.log("上传图片成功之后", res);
      const {
        data: { name, url },
      } = res;
      const item = {
        name: name || "",
        url: url || "",
      };
      this.photoList.push(item);
    },
    // 删除图片
    uploadRemove(file, fileList) {
      this.photoList = fileList;
    },
    // 上传图片限制
    uploadExceed() {
      this.$message.warning("最多上传五张图片");
    },
    getList() {
      const { search, pageSize, pageNum } = this;
      this.$store
        .dispatch("pickUp/getCredentialAuditList", {
          ...search,
          size: pageSize,
          current: pageNum,
        })
        .then((data) => {
          const { results, total, count } = data;
          const list = results.map((item) => {
            const { goodsName, goodsPic, goodsQuantity, goodsSpec } = item.orderGoodsList;
            const imgList = item.sellerVoucherImgUrl ? JSON.parse(item.sellerVoucherImgUrl) : [];
            return {
              ...item,
              goodsPic,
              goodsName,
              goodsSpec,
              goodsQuantity,
              sellerVoucherImgUrl: imgList,
            };
          });
          this.list = list;
          this.totalPage = total;
          this.pageTotal = count;
        });
    },
    searchList() {
      const startTime = this.timeList[0];
      const endTime = this.timeList[1];
      this.search = {
        ...this.search,
        endTime,
        startTime,
      };
      this.getList();
    },
    resetList() {
      this.timeList = [];
      this.pageNum = 1;
      this.pageSize = 30;
      this.search = {
        startTime: "",
        endTime: "",
        orderId: "",
        linkman: "",
      };
    },
    // 修改每页显示个数
    sizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageNum = 1;
      this.getList();
    },

    // 修改页码
    currentChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },

    // 审核
    audit(id) {
      console.log("id", id);
      this.$confirm("是否确认审核通过？", "审核通过", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // 14 通过传1，驳回传2
        const arg = {
          id,
          approvalStatus: 1,
        };
        this.auitFrom(arg, "审核通过");
      });
    },
    reject(id) {
      this.$prompt("请填写驳回原因", "审核驳回", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValidator(value) {
          if (!value) {
            return "请填写驳回原因";
          }
        },
        inputErrorMessage: "请填写驳回原因",
      }).then(({ value }) => {
        const arg = {
          id,
          approvalStatus: 2,
          rejectReason: value,
        };
        this.auitFrom(arg, "驳回成功");
      });
    },
    auitFrom(arg, msg) {
      this.$store.dispatch("pickUp/credentialAudit", arg).then((res) => {
        if (res.code === "0") {
          this.$message.success(msg);
          this.getList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    rejectRause(msg) {
      // alert
      this.$alert(msg, "驳回原因");
    },
  },
  // 监听器
  filters: {},
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
